
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class AuthFluidContent extends Vue {
  @Prop() private msg!: string;
}
